import { getAPI } from "./axios-base";
import Admin from "@/models/Admin";

interface GetSellerParams {
  skip: number;
  limit: number;
  q: string;
  name: string;
  email: string;
}
export default class RestResourceSeller {
  getSellers(params: GetSellerParams) {
    return getAPI.get(`api/rest/v1/user`, { params });
  }
  getSeller(id: string) {
    return getAPI.get(`api/rest/v1/user/${id}`);
  }
  putSeller(id: string, body: any) {
    return getAPI.put(`api/rest/v1/user/${id}`, body);
  }
}
